// CSS imports
import './styles/analysis.css';

// JavaScript imports
import { getGeoJsonData, fetchAllGeoData, getLinkData } from "./config/firebase";



// initilize map
// signle map instance
const map = L.map('map').setView([35.45795830898374, 37.327734312557624], 2);
// var markersClusterGroup = new L.markerClusterGroup();
L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
                attribution: 'AY Maps &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
}).addTo(map);
const eventsLayer =  L.layerGroup().addTo(map);

function clearMapLayers(){
    // markersClusterGroup.clearLayers();
    eventsLayer.clearLayers();

}

let allData = []; 
var totalEventsText = `Total Events in Palestine 2024`;


const DATA_COUNT = 12;
const NUMBER_CFG = {count: DATA_COUNT, min: -100, max: 100};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const data = {
    labels: labels,
    datasets: [
      {
        label: 'Air/drone strike',
        data: [],
        borderColor: 'red',
        backgroundColor: 'red',
      },
      {
        label: 'Armed clash',
        data: [],
        borderColor: 'blue',
        backgroundColor: 'blue',
      },
      {
        label: 'Attack',
        data: [],
        borderColor: 'pink',
        backgroundColor: 'pink',
      },
      {
        label: 'Shelling/artillery/missile attack',
        data: [],
        borderColor: 'green',
        backgroundColor: 'green',
      },
      {
        label: 'Other',
        data: [],
        borderColor: 'black',
        backgroundColor: 'black',
      }
    ]
};
  
const config = {
    type: 'bar',
    data: data,
    options: {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: totalEventsText
        }
      }
    },
};

const chart = new Chart(document.getElementById('chart'), config);

window.onload = async function () {
  
 
  await fetchAllData();
  fetchCSVData("Palestine");

  var triggerTabList = [].slice.call(document.querySelectorAll('#pills-tab a'))
  triggerTabList.forEach(function (triggerEl) {
    var tabTrigger = new bootstrap.Tab(triggerEl)
    triggerEl.addEventListener('click', function (event) {
        event.preventDefault()
        tabTrigger.show()
        console.log("event", event.target.text);
        clearMapLayers();

         // Update totalEventsText and chart title
         totalEventsText = `Total Events in ${event.target.text} 2024`;
         config.options.plugins.title.text = totalEventsText;
         fetchCSVData(event.target.text);

     });
  });
}


        
// DONE: Fetch data and update map and chart

async function fetchAllData(){
    const link = await getLinkData();
    allData = await d3.csv(link);
    console.log("allData", allData.length);
} 

async function fetchCSVData(countryName){
  let eventCounts = { 'Air/drone strike' : Array(12).fill(0), 'Armed clash': Array(12).fill(0)
                    , 'Attack': Array(12).fill(0), 'Shelling/artillery/missile attack': Array(12).fill(0),
                      'Other': Array(12).fill(0)};
  var markersClusterGroup = new L.markerClusterGroup();

  // Filter the data from the global variable based on the selected country
  var filteredData = allData.filter(d => d.country === countryName);
  console.log("data length", filteredData.length);
 
  for (const d of filteredData) {
      const eventType = eventCounts.hasOwnProperty(d.sub_event_type) ? d.sub_event_type : 'Other';
      const date = new Date(d.event_date);
      const month = date.getMonth(); // getMonth() returns the month (0-11)
      eventCounts[eventType][month]++;
      
      var marker = L.marker([d.latitude, d.longitude]);
      markersClusterGroup.addLayer(marker);
  }
  eventsLayer.addLayer(markersClusterGroup);

  // Update chart data
  data.datasets.forEach(dataset => {
      if (eventCounts.hasOwnProperty(dataset.label)) {
          dataset.data = eventCounts[dataset.label];
      }
  });
  chart.update();
}

// async function fetchCSVData(countryName){

//     const link = await getLinkData();
//     let eventCounts = { 'Air/drone strike' : Array(12).fill(0), 'Armed clash': Array(12).fill(0)
//                       , 'Attack': Array(12).fill(0), 'Shelling/artillery/missile attack': Array(12).fill(0),
//                         'Other': Array(12).fill(0)};
//     var markersClusterGroup = new L.markerClusterGroup();


//     await d3.csv(link).then(data => {
      
//         var filteredData = data.filter(d => d.country === countryName);
//         console.log("data length", filteredData.length);
       
//         for (const d of filteredData) {
//             // TODO: count the data here acording to each event group.
            
//             // eventCounts[d.sub_event_type] = (eventCounts[d.sub_event_type] || 0) + 1;
//             const eventType = eventCounts.hasOwnProperty(d.sub_event_type) ? d.sub_event_type : 'Other';
//             const date = new Date(d.event_date);
//             const month = date.getMonth(); // getMonth() returns the month (0-11)
//             eventCounts[eventType][month]++;
            
//             var marker = L.marker([d.latitude, d.longitude]);
//             markersClusterGroup.addLayer(marker);
//         }
//         eventsLayer.addLayer(markersClusterGroup);
//     }).catch(error => {
//         console.error("Error getting or processing CSV data:", error);
//     });

//     // Update chart data
//   data.datasets.forEach(dataset => {
//   // Replace dataset data with event counts
//       if (eventCounts.hasOwnProperty(dataset.label)) {
//           dataset.data = eventCounts[dataset.label];
//       }
//   });
//       // data.datasets.forEach(dataset => {
//       //     // Push event counts to chart data
//       //     dataset.data.push(eventCounts[dataset.label]);
//       // });
//   chart.update();
// }


async function palestineMap(countryName){
  const map = L.map('map').setView([35.45795830898374, 37.327734312557624], 2);
var markersClusterGroup = new L.markerClusterGroup();
L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
                attribution: 'AY Maps &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
}).addTo(map);
const eventsLayer =  L.layerGroup().addTo(map);
const link = await getLinkData();
    let eventCounts = { 'Air/drone strike' : Array(12).fill(0), 'Armed clash': Array(12).fill(0)
                      , 'Attack': Array(12).fill(0), 'Shelling/artillery/missile attack': Array(12).fill(0),
                        'Other': Array(12).fill(0)};

    await d3.csv(link).then(data => {
      
        var filteredData = data.filter(d => d.country === countryName);
        console.log("data", filteredData.length);
       
        for (const d of filteredData) {
            // TODO: count the data here acording to each event group.
            
            // eventCounts[d.sub_event_type] = (eventCounts[d.sub_event_type] || 0) + 1;
            const eventType = eventCounts.hasOwnProperty(d.sub_event_type) ? d.sub_event_type : 'Other';
            const date = new Date(d.event_date);
            const month = date.getMonth(); // getMonth() returns the month (0-11)
            eventCounts[eventType][month]++;
            
            var marker = L.marker([d.latitude, d.longitude]);
            markersClusterGroup.addLayer(marker);
        }
        eventsLayer.addLayer(markersClusterGroup);
    }).catch(error => {
        console.error("Error getting or processing CSV data:", error);
    });

    // Update chart data
  data.datasets.forEach(dataset => {
  // Replace dataset data with event counts
      if (eventCounts.hasOwnProperty(dataset.label)) {
          dataset.data = eventCounts[dataset.label];
      }
  });
      // data.datasets.forEach(dataset => {
      //     // Push event counts to chart data
      //     dataset.data.push(eventCounts[dataset.label]);
      // });
  chart.update();
}

async function syrianMap(countryName){
  const map = L.map('map').setView([35.45795830898374, 37.327734312557624], 2);
var markersClusterGroup = new L.markerClusterGroup();
L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
                attribution: 'AY Maps &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
}).addTo(map);
const eventsLayer =  L.layerGroup().addTo(map);
const link = await getLinkData();
    let eventCounts = { 'Air/drone strike' : Array(12).fill(0), 'Armed clash': Array(12).fill(0)
                      , 'Attack': Array(12).fill(0), 'Shelling/artillery/missile attack': Array(12).fill(0),
                        'Other': Array(12).fill(0)};

    await d3.csv(link).then(data => {
      
        var filteredData = data.filter(d => d.country === countryName);
        console.log("data", filteredData.length);
       
        for (const d of filteredData) {
            // TODO: count the data here acording to each event group.
            
            // eventCounts[d.sub_event_type] = (eventCounts[d.sub_event_type] || 0) + 1;
            const eventType = eventCounts.hasOwnProperty(d.sub_event_type) ? d.sub_event_type : 'Other';
            const date = new Date(d.event_date);
            const month = date.getMonth(); // getMonth() returns the month (0-11)
            eventCounts[eventType][month]++;
            
            var marker = L.marker([d.latitude, d.longitude]);
            markersClusterGroup.addLayer(marker);
        }
        eventsLayer.addLayer(markersClusterGroup);
    }).catch(error => {
        console.error("Error getting or processing CSV data:", error);
    });

    // Update chart data
  data.datasets.forEach(dataset => {
  // Replace dataset data with event counts
      if (eventCounts.hasOwnProperty(dataset.label)) {
          dataset.data = eventCounts[dataset.label];
      }
  });
      // data.datasets.forEach(dataset => {
      //     // Push event counts to chart data
      //     dataset.data.push(eventCounts[dataset.label]);
      // });
  chart.update();

}

async function israelMap(countryName){
  const map = L.map('map').setView([35.45795830898374, 37.327734312557624], 2);
var markersClusterGroup = new L.markerClusterGroup();
L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
                attribution: 'AY Maps &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
}).addTo(map);
const eventsLayer =  L.layerGroup().addTo(map);
const link = await getLinkData();
    let eventCounts = { 'Air/drone strike' : Array(12).fill(0), 'Armed clash': Array(12).fill(0)
                      , 'Attack': Array(12).fill(0), 'Shelling/artillery/missile attack': Array(12).fill(0),
                        'Other': Array(12).fill(0)};

    await d3.csv(link).then(data => {
      
        var filteredData = data.filter(d => d.country === countryName);
        console.log("data", filteredData.length);
       
        for (const d of filteredData) {
            // TODO: count the data here acording to each event group.
            
            // eventCounts[d.sub_event_type] = (eventCounts[d.sub_event_type] || 0) + 1;
            const eventType = eventCounts.hasOwnProperty(d.sub_event_type) ? d.sub_event_type : 'Other';
            const date = new Date(d.event_date);
            const month = date.getMonth(); // getMonth() returns the month (0-11)
            eventCounts[eventType][month]++;
            
            var marker = L.marker([d.latitude, d.longitude]);
            markersClusterGroup.addLayer(marker);
        }
        eventsLayer.addLayer(markersClusterGroup);
    }).catch(error => {
        console.error("Error getting or processing CSV data:", error);
    });

    // Update chart data
  data.datasets.forEach(dataset => {
  // Replace dataset data with event counts
      if (eventCounts.hasOwnProperty(dataset.label)) {
          dataset.data = eventCounts[dataset.label];
      }
  });
      // data.datasets.forEach(dataset => {
      //     // Push event counts to chart data
      //     dataset.data.push(eventCounts[dataset.label]);
      // });
  chart.update();
}

// d3.csv(link).then(function (data) {
//     // Initialize map and chart
//     const map = L.map('map').setView([35.45795830898374, 37.327734312557624], 2);
//     L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//         // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
//         attribution: 'AY Maps &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
//     }).addTo(map);
//     const markers = L.layerGroup().addTo(map);
    
//     var filteredData = data.filter(d => d.country === "Syria");

//     const chart = new Chart(document.getElementById('chart'), {
//         type: 'bar',
//         data: {
//             datasets: [
//                 { label: 'Air/drone strike', data: [], backgroundColor: 'red' },
//                 { label: 'Shelling/artillery/missile attack', data: [], backgroundColor: 'blue' },
//                 { label: 'Attack', data: [], backgroundColor: 'pink' },

//                 // Add more datasets as needed
//             ]
//         },
//         options: {
//             onClick: function (e) {
//                 const activePoints = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
//                 if (activePoints.length > 0) {
//                     const firstPoint = activePoints[0];
//                     const label = chart.data.datasets[firstPoint.datasetIndex].label;
//                     // Filter markers on map
//                     markers.eachLayer(function (layer) {
//                         if (layer.options.subEventType !== label) {
//                             map.removeLayer(layer);
//                         }
//                     });
//                 }
//             }
//         }
//     });

//     // Initialize event counts object
//     const eventCounts = {};

//     // Iterate over data
//     filteredData.forEach(d => {
//         const date = new Date(Date.parse(d.event_date));
//         const month = date.toLocaleString('default', { month: 'short' });
//         const key = `${month}-${d.sub_event_type}`;
//         eventCounts[key] = (eventCounts[key] || 0) + 1;
//         const dataset = chart.data.datasets.find(ds => ds.label === d.sub_event_type);

//         if (dataset) {
//             dataset.data.push({ x: month, y: eventCounts[key] });
//         }
//         const marker = L.marker([d.latitude, d.longitude], { subEventType: d.sub_event_type });
//         markers.addLayer(marker);
//     });


//     // Update chart
//     chart.update();

//     console.log("eventCounts", eventCounts);
// });
